import type { ResponseRead, ResponseReadAll } from "epsm-api-types";
import { Converter } from "epsm-api-types/converter";
import type { ScreenerState } from "epsm-api-types/models";
import { BaseService } from "@/services/BaseService";
import { HttpClient, type IHttpClient } from "@/services/HttpClient";

export class ScreenerStateService extends BaseService<
	ScreenerState,
	ScreenerState
> {
	private constructor(private httpClient: IHttpClient) {
		super(new Converter());
	}

	private static instance: ScreenerStateService;

	static create() {
		if (!ScreenerStateService.instance) {
			ScreenerStateService.instance = new ScreenerStateService(
				HttpClient.create(),
			);
		}
		return ScreenerStateService.instance;
	}

	async addState(userId: string, itemName: string, data: ScreenerState) {
		await this.httpClient.put<ResponseReadAll<ScreenerState>>(
			`/screener/state/${userId}/${itemName}`,
			{ data },
		);
	}

	async getStates(userId: string): Promise<ResponseReadAll<ScreenerState>> {
		const response = await this.httpClient.get<ResponseReadAll<ScreenerState>>(
			`/screener/state/${userId}`,
		);

		return this.getResponseReadAll(response);
	}

	async getState(
		userId: string,
		itemName: string,
	): Promise<ResponseRead<ScreenerState>> {
		const response = await this.httpClient.get<ResponseRead<ScreenerState>>(
			`/screener/state/${userId}/${itemName}`,
		);

		return this.getResponseItem(response);
	}

	async removeState(userId: string, itemName: string) {
		await this.httpClient.delete<ResponseRead<ScreenerState>>(
			`/screener/state/${userId}/${itemName}`,
		);
	}
}
